
import {
    IOptionPickerColorItem,
    OptionPickerItemState,
    OPTION_PICKER_TYPE_COLOR,
} from '@vfde-brix/option-picker';
import mountOptionPicker from './mountOptionPicker';
import { COLOR_KEY } from '../container/Options/constants';
import { StateProps } from 'app/container/Options/interfaces/state';

/**
 * Mount the color picker
 *
 * @param containerId
 * @param colors
 * @param currentColor
 * @param onChangeAction
 */
export const mountColorOptionPicker = (containerId: string, { colors, currentColor }: StateProps, onChangeAction?: (value: string) => void) => {
    const items: IOptionPickerColorItem[] = [];

    for (const [index, color] of colors!.entries()) {
        let state: OptionPickerItemState | undefined;

        if (currentColor === color[COLOR_KEY] || index === 0) {
            state = 'checked';
        }

        items.push({
            stdValue: color[COLOR_KEY],
            stdColorName: color[COLOR_KEY],
            stdColorRgbValue: color.rgb,
            optState: state,
        });
    }

    const onChange = (event: Event) => {
        const target = event.target as HTMLInputElement;
        onChangeAction && onChangeAction(target.value);
    };

    return mountOptionPicker(containerId, 'color-picker', OPTION_PICKER_TYPE_COLOR, items, onChange);
};
